import ThisModule from "./PageError";

export default ThisModule;
